module.exports = __webpack_public_path__ + "static/sf-skyline-2020-mobile-665d4c8e697853c3e66bdd8f7a10c42e.svg";